import React, { useState } from 'react'
import { analytics } from 'Modules/Analytics'
import { initiatives } from 'Modules/Analytics/trackActionInterface/Impact/Initiatives'
import { useAppState } from 'Context/AppContext/AppContext'
import { Button, Popover } from '@material-ui/core'
import { DeleteOutline as DeleteIcon } from '@mui/icons-material'
import { MoreVertIcon } from '@resiliatech/birdsong'
import { DeleteChartModal } from './DeleteChartModal'
import {
  ChartListMenuIcon,
  ChartMenuItemContainer,
  ChartMenuItemIcon,
  ChartMenuItemText,
  ChartMenuListItem,
} from './ChartMenu.styled'

type ChartMenuProps = {
  chartMenuOpen: boolean
  menuAnchor: HTMLElement | null
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void
  onClose: () => void
  onDeleteChart: () => void
}

export const ChartMenu: React.FC<ChartMenuProps> = ({
  chartMenuOpen,
  menuAnchor,
  onClick,
  onClose,
  onDeleteChart,
}) => {
  const {
    nonprofitOrgConfig: { role, nonprofitOrgRole },
  } = useAppState()
  const [showDeleteChartModal, setShowDeleteChartModal] = useState(false)
  const handleDeleteClick = () => {
    setShowDeleteChartModal(true)
    onClose()
    analytics.trackActionCreator(initiatives.Goal_Chart_Delete_Clicked)({
      role,
      relationship: nonprofitOrgRole,
    })
  }
  return (
    <>
      <Button onClick={onClick}>
        <ChartListMenuIcon>
          <MoreVertIcon />
        </ChartListMenuIcon>
      </Button>

      <Popover
        anchorEl={menuAnchor}
        open={chartMenuOpen}
        onClose={onClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <ChartMenuItemContainer>
          <ChartMenuListItem button onClick={handleDeleteClick}>
            <ChartMenuItemIcon>
              <DeleteIcon />
            </ChartMenuItemIcon>
            <ChartMenuItemText primary='Delete Chart and Data' />
          </ChartMenuListItem>
        </ChartMenuItemContainer>
      </Popover>
      <DeleteChartModal
        isOpen={showDeleteChartModal}
        onClose={() => setShowDeleteChartModal(false)}
        onDeleteChart={onDeleteChart}
      />
    </>
  )
}
